import React, { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { LoaderIcon } from '../Global/Icons';
import { exportAsCsv, exportAsJson, exportAsPdf } from '../../Models/Export';
import Phase from '../../Models/Phase';
import Project from '../../Models/Project';
import { useParams } from 'react-router-dom';



interface ExportButtonProps {
	data: Project | Phase;
	errorCallback?: (message: string) => void
}

const ExportButton: React.FC<ExportButtonProps> = ({ data, errorCallback }) => {
	const { instance, accounts } = useMsal();
	const [isLoading, setIsLoading] = useState(false);
	 const { id } = useParams();

	const downloadJSON = () => { exportAsJson(data) };
	const downloadCSV = () => { exportAsCsv(data) };
	const downloadPDF = async () => {
		setIsLoading(true);
		try {
			await exportAsPdf(data, instance, accounts[0],id);
		} catch {
			errorCallback('There was an error fetching your PDF report');
		}
		setIsLoading(false);
	};

	return (
		<DropdownButton variant='secondary' title={isLoading ? <><LoaderIcon width={16} className='me-2' />Loading</> : <>Download  </>}>
			<Dropdown.Item onClick={downloadPDF}  className='bg-basic text-center pt-3 ms-n3 rounded-top mt-1'>Download PDF</Dropdown.Item>
			<Dropdown.Item onClick={downloadCSV}  className='bg-basic text-center py-3 ms-n3'>Download CSV</Dropdown.Item>
			<Dropdown.Item onClick={downloadJSON} className='bg-basic text-center pb-3 ms-n3 rounded-bottom'>Download JSON</Dropdown.Item>
		</DropdownButton>
	);
};

export default ExportButton;